import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ShapedButton from './ShapedButton';
import SvgIcon from './SvgIcon';

const ArrowBackButton = ({ ariaLabel, className, onClick, text, isEnabled }) => (
    <ShapedButton
        ariaLabel={ariaLabel}
        styles={classNames('arrow-back-button', className, { blocked: !isEnabled })}
        text={text}
        onClick={onClick}
        isEnabled={isEnabled}
    >
        <SvgIcon ariaLabel="OK" class="svg-button lantern-svg" id="ok-button" />
    </ShapedButton>
);

ArrowBackButton.propTypes = {
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string,
    isEnabled: PropTypes.bool,
};

ArrowBackButton.defaultProps = {
    ariaLabel: '',
    text: 'Back',
    className: '',
    isEnabled: true,
};

export default ArrowBackButton;
